import {
  OvertimeDetail,
  SumOfCategoriesWithTemporarySum,
  YearMonth,
} from '@wilson/interfaces';
import { WorkTimeCache } from './work-time-cache.class';
import { UserWorktimeGatewayService } from '@wilson/api/gateway';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@wilson/auth/core';

export class PayrollCategoriesSummaryCache extends WorkTimeCache<
  YearMonth,
  OvertimeDetail<SumOfCategoriesWithTemporarySum>[]
> {
  private readonly userWorktimeGatewayService = inject(
    UserWorktimeGatewayService,
  );
  private readonly store = inject(Store);
  constructor() {
    super({
      dataFactory: (month) => {
        const userId = this.store.selectSnapshot(AuthState.userId) as string;
        return this.userWorktimeGatewayService.getPayrollCategoriesSummary<
          OvertimeDetail<SumOfCategoriesWithTemporarySum>
        >(userId, month, true);
      },
    });
  }
}
